import React from 'react';
import { createRoot } from 'react-dom/client';
import { MemberApp, ErrorBoundary } from './components/App.jsx';
import { MemberController } from './lib/controller.js';
import { registerShell } from './lib/pwa.js';
import './styles.css';
import './ux-clarity.css';
const controller = new MemberController();
const root = createRoot(document.getElementById('root'));
root.render(<ErrorBoundary><MemberApp controller={controller}/></ErrorBoundary>);
controller.boot();
// No service worker from a dev server. Generated precache exists only after the Vite build.
if (import.meta.env.PROD) registerShell(activate=>{
  controller.activateUpdate=()=>{if(controller.state.rows.length||controller.state.workout?.status==='active')return false;navigator.serviceWorker.addEventListener('controllerchange',()=>location.reload(),{once:true});activate();return true;};
  controller.patch({updateAvailable:true});
}).catch(()=>controller.patch({notice:'Çevrimdışı uygulama kabuğu kurulamadı. Açık ekrandaki set kaydı ayrı IndexedDB kuyruğunda korunur.'}));
